﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbContent
})
export class KbContent extends Directive {
    constructor() {
        super();

        this.restrict = "A";
        this.scope = false;

        this.link = (scope: any, element, atts: any) => {
            element.addClass("ng-binding").data("$binding", atts.kbContent);
            scope.$watch(atts.kbContent, value => {
                element.html(value || "");
            });
        };

    }
}
